import EnumDataSource from "utils/enum-data-source.util";

export const TEMPLATES_LIMIT = 25;

export const TEMPLATE_TYPE_CHART_NOTE = 1;
export const TEMPLATE_TYPE_REPORT_SUMMARY = 2;
export const TEMPLATE_TYPE_DOCUMENT = 3;
export const TEMPLATE_TYPE_MESSAGE = 4;
export const TEMPLATE_TYPE_FAX = 5;
export const TEMPLATE_TYPE_CLASSIC_EMAIL = 6;
export const TEMPLATE_TYPE_TASK = 7;
export const TEMPLATE_TYPE_SALE_NOTE = 8;
export const TEMPLATE_TYPE_NEW_APPOINTMENT_NOTE = 9;
export const TEMPLATE_TYPE_FORM = 10;
export const TEMPLATE_TYPE_PURCHASE_AGREEMENT = 11;
export const TEMPLATE_TYPE_DESIGNER_EMAIL = 12;
export const TEMPLATE_TYPE_SNIPPET = 99;

export const TEMPLATE_TYPES_NON_FORMS = [
  TEMPLATE_TYPE_CHART_NOTE,
  TEMPLATE_TYPE_REPORT_SUMMARY,
  TEMPLATE_TYPE_DOCUMENT,
  TEMPLATE_TYPE_MESSAGE,
  TEMPLATE_TYPE_FAX,
  TEMPLATE_TYPE_CLASSIC_EMAIL,
  TEMPLATE_TYPE_DESIGNER_EMAIL,
  TEMPLATE_TYPE_TASK,
  TEMPLATE_TYPE_SALE_NOTE,
  TEMPLATE_TYPE_NEW_APPOINTMENT_NOTE,
  TEMPLATE_TYPE_SNIPPET,
  TEMPLATE_TYPE_FORM
];

export const TEMPLATE_TYPES_FORMS = [TEMPLATE_TYPE_PURCHASE_AGREEMENT];

const templateTypes = {
  [TEMPLATE_TYPE_CHART_NOTE]: "Chart Note",
  [TEMPLATE_TYPE_REPORT_SUMMARY]: "Report Summary",
  [TEMPLATE_TYPE_DOCUMENT]: "Document",
  [TEMPLATE_TYPE_MESSAGE]: "Text Message",
  [TEMPLATE_TYPE_FAX]: "Fax Cover Letter",
  [TEMPLATE_TYPE_CLASSIC_EMAIL]: "Classic Email",
  [TEMPLATE_TYPE_DESIGNER_EMAIL]: "Designer Email",
  [TEMPLATE_TYPE_SALE_NOTE]: "Sale Notes/Memo",
  [TEMPLATE_TYPE_NEW_APPOINTMENT_NOTE]: "New Appointment Note",
  [TEMPLATE_TYPE_SNIPPET]: "Snippet"
};

const textTemplateTypesOrder = {
  [TEMPLATE_TYPE_CHART_NOTE]: 1,
  [TEMPLATE_TYPE_REPORT_SUMMARY]: 2,
  [TEMPLATE_TYPE_DOCUMENT]: 3,
  [TEMPLATE_TYPE_MESSAGE]: 4,
  [TEMPLATE_TYPE_FAX]: 5,
  [TEMPLATE_TYPE_CLASSIC_EMAIL]: 6,
  [TEMPLATE_TYPE_DESIGNER_EMAIL]: 7,
  [TEMPLATE_TYPE_SALE_NOTE]: 8,
  [TEMPLATE_TYPE_NEW_APPOINTMENT_NOTE]: 9,
  [TEMPLATE_TYPE_SNIPPET]: 10,
  [TEMPLATE_TYPE_TASK]: 11,
  [TEMPLATE_TYPE_FORM]: 12,
  [TEMPLATE_TYPE_PURCHASE_AGREEMENT]: 13
};

export const DEFAULT_TEMPLATE_TYPES = [
  TEMPLATE_TYPE_CHART_NOTE,
  TEMPLATE_TYPE_REPORT_SUMMARY,
  TEMPLATE_TYPE_SNIPPET
];

export const EMAIL_TEMPLATE_TYPES = [
  TEMPLATE_TYPE_CLASSIC_EMAIL,
  TEMPLATE_TYPE_SNIPPET
];

export const EMAIL_TEMPLATE_WITH_DESIGN_TYPES = [
  TEMPLATE_TYPE_CLASSIC_EMAIL,
  TEMPLATE_TYPE_SNIPPET,
  TEMPLATE_TYPE_DESIGNER_EMAIL
];

export const EMAIL_TEMPLATE_DESIGN_ONLY_TYPES = [TEMPLATE_TYPE_DESIGNER_EMAIL];

export const FAX_TEMPLATE_TYPES = [TEMPLATE_TYPE_FAX, TEMPLATE_TYPE_SNIPPET];

export const DOCUMENT_TEMPLATE_TYPES = [
  ...EMAIL_TEMPLATE_TYPES,
  TEMPLATE_TYPE_DOCUMENT
];

export const TASK_TEMPLATE_TYPES = [
  TEMPLATE_TYPE_TASK,
  TEMPLATE_TYPE_MESSAGE,
  TEMPLATE_TYPE_SNIPPET
];

export const MESSAGE_TEMPLATE_TYPES = [TEMPLATE_TYPE_MESSAGE];

export const PRINTABLE_FORM_TEMPLATE_TYPES = [
  TEMPLATE_TYPE_FORM,
  TEMPLATE_TYPE_CHART_NOTE,
  TEMPLATE_TYPE_NEW_APPOINTMENT_NOTE,
  TEMPLATE_TYPE_SNIPPET
];

export const TEXT_TEMPLATE_TYPES = new EnumDataSource(
  templateTypes,
  textTemplateTypesOrder
);

export const TEXT_TEMPLATE_TYPES_V2 = new EnumDataSource(
  {
    ...templateTypes,
    [TEMPLATE_TYPE_TASK]: "Task"
  },
  textTemplateTypesOrder
);

export const TEXT_TEMPLATE_TYPES_V3 = new EnumDataSource(
  {
    ...templateTypes,
    [TEMPLATE_TYPE_TASK]: "Task",
    [TEMPLATE_TYPE_FORM]: "Form",
    [TEMPLATE_TYPE_PURCHASE_AGREEMENT]: "Purchase Agreement"
  },
  textTemplateTypesOrder
);

export const TEXT_TEMPLATE_TYPES_NON_FORMS = new EnumDataSource(
  {
    ...templateTypes,
    [TEMPLATE_TYPE_TASK]: "Task",
    [TEMPLATE_TYPE_FORM]: "Form"
  },
  textTemplateTypesOrder
);

export const TEXT_TEMPLATE_TYPES_FORMS = new EnumDataSource({
  [TEMPLATE_TYPE_PURCHASE_AGREEMENT]: "Purchase Agreement"
});

export const INVOICE_TEMPLATE_TYPES = [
  TEMPLATE_TYPE_SALE_NOTE,
  TEMPLATE_TYPE_SNIPPET
];

export const TEXT_ONLY_TEMPLATE_TYPES = [
  TEMPLATE_TYPE_MESSAGE,
  TEMPLATE_TYPE_TASK,
  TEMPLATE_TYPE_SALE_NOTE,
  TEMPLATE_TYPE_NEW_APPOINTMENT_NOTE
];

export const TEXT_MESSAGE_MAX_LENGTH = 320;
export const TEXT_MESSAGE_BACKEND_MAX_LENGTH = 1600;
export const EMAIL_SUBJECT_MAX_LENGTH = 255;
